import { CustomerType } from "@origin-digital/platform-enums";
import { BasicJSONSchema, IMcAppType, NavFlow, Tab } from "../mcApp.types";

const voucherId: BasicJSONSchema = {
  description: "hashed fuel voucher id",
  type: "string",
};

export const rewardBarcode: IMcAppType = {
  name: "rewardBarcode_SAP",
  path: "/my-account/reward/barcode",
  parameters: {
    required: ["voucherId"],
    properties: { voucherId },
  },
  description: "Reward barcode for fuel discount",
  navFlow: NavFlow.MODAL,
  title: "EG Fuel offer",
  parent: Tab.DASHBOARD,
  conditions: {
    intent: "rewardBarcode",
    customerType: CustomerType.sap,
  },
};

export const rewardBarcode_KRAKEN: IMcAppType = {
  name: "rewardBarcode_KRAKEN",
  path: "/my/reward/barcode",
  parameters: {
    required: ["voucherId"],
    properties: { voucherId },
  },
  description: "Reward barcode for fuel discount",
  navFlow: NavFlow.MODAL,
  title: "EG Fuel offer",
  parent: Tab.DASHBOARD,
  conditions: {
    intent: "rewardBarcode",
    customerType: CustomerType.kraken,
  },
};

export const reward: IMcAppType = {
  name: "reward_SAP",
  path: "/my-account/reward",
  description: "Reward page for fuel discount",
  navFlow: NavFlow.STANDARD,
  title: "EG Fuel offer",
  parent: Tab.DASHBOARD,
  conditions: {
    intent: "reward",
    customerType: CustomerType.sap,
  },
};

export const reward_KRAKEN: IMcAppType = {
  name: "reward_KRAKEN",
  path: "/my/reward",
  description: "Reward page for fuel discount",
  navFlow: NavFlow.STANDARD,
  title: "EG Fuel offer",
  parent: Tab.DASHBOARD,
  conditions: {
    intent: "reward",
    customerType: CustomerType.kraken,
  },
};

export const fuelRewardBarcode: IMcAppType = {
  name: "fuelRewardBarcode_SAP",
  path: "/my-account/reward/fuel/barcode",
  parameters: {
    required: ["voucherId"],
    properties: { voucherId },
  },
  description: "Fuel reward barcode for fuel discount",
  navFlow: NavFlow.MODAL,
  title: "EG Fuel offer",
  parent: Tab.DASHBOARD,
  conditions: {
    intent: "fuelRewardBarcode",
    customerType: CustomerType.sap,
  },
};

export const fuelRewardBarcode_KRAKEN: IMcAppType = {
  name: "fuelRewardBarcode_KRAKEN",
  path: "/my/reward/fuel/barcode",
  parameters: {
    required: ["voucherId"],
    properties: { voucherId },
  },
  description: "Reward barcode for fuel discount",
  navFlow: NavFlow.MODAL,
  title: "EG Fuel offer",
  parent: Tab.DASHBOARD,
  conditions: {
    intent: "fuelRewardBarcode",
    customerType: CustomerType.kraken,
  },
};

export const fuelReward: IMcAppType = {
  name: "fuelReward_SAP",
  path: "/my-account/reward/fuel",
  description: "Reward page for fuel discount",
  navFlow: NavFlow.STANDARD,
  title: "EG Fuel offer",
  parent: Tab.DASHBOARD,
  conditions: {
    intent: "fuelReward",
    customerType: CustomerType.sap,
  },
};

export const fuelReward_KRAKEN: IMcAppType = {
  name: "fuelReward_KRAKEN",
  path: "/my/reward/fuel",
  description: "Reward page for fuel discount",
  navFlow: NavFlow.STANDARD,
  title: "EG Fuel offer",
  parent: Tab.DASHBOARD,
  conditions: {
    intent: "fuelReward",
    customerType: CustomerType.kraken,
  },
};
